// ----------------------------------------------------------------
// <copyright company="Microsoft Corporation">
//     Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { combineReducers } from 'redux';

import actionStatusReducer from './actionStatus';
import addressValidationReducer from './address/reducer';
import countriesReducer from './countries/countriesReducer';
import deviceReducer from './deviceInfo';
import hiddenAnnouncementReducer from './hiddenAnnouncement';
import orderReducer from './orderCreation';
import provincesReducer from './provinces';
import selectedCountryCodeReducer from './countries/selectedCountryReducer';
import userInfoReducer from './user/userInfoReducer';
import usersReducer from './manageUsers/usersReducer';
import attachmentReducer from './attachments';
import managePartnersReducer from './managePartners/managePartnersReducer';
import manageAadOpsReducer from './manageAadOps/manageAadOpsReducer';

export default combineReducers({
    addressInfo: addressValidationReducer,
    actionStatus: actionStatusReducer,
    countries: countriesReducer,
    device: deviceReducer,
    countryInfo: selectedCountryCodeReducer,
    hiddenAnnouncement: hiddenAnnouncementReducer,
    manageUsers: usersReducer,
    order: orderReducer,
    provinces: provincesReducer,
    userInfo: userInfoReducer,
    attachmentInfo: attachmentReducer,
    managePartners: managePartnersReducer,
    manageAadUsers: manageAadOpsReducer,
});
